export default {
      id: "xtype_pro_vision-usage",
      viewBox: "0 0 21 17",
      url: __webpack_public_path__ + "img/icons.svg#xtype_pro_vision",
      toString: function () {
        return this.url;
      }
    }